/* CAMS JEWELRY — interactions thème Shopify
   Panier AJAX, tiroir, menu mobile, recherche, favoris, filtres, toast. */
(function () {
  "use strict";

  var money = window.Shopify && Shopify.formatMoney
    ? function (cents) { return Shopify.formatMoney(cents, window.camsMoneyFormat || "€{{amount}}"); }
    : function (cents) { return "€" + (cents / 100).toFixed(2); };

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ── Toast ─────────────────────────────────────────────── */
  var toastEl = $("#cams-toast");
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    $(".toast-msg", toastEl).textContent = msg;
    toastEl.classList.add("is-on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove("is-on"); }, 2800);
  }

  /* ── Header compact au scroll ──────────────────────────── */
  var header = $("[data-header]");
  if (header) {
    var onScroll = function () { header.classList.toggle("is-compact", window.scrollY > 60); };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ── Recherche inline ──────────────────────────────────── */
  var searchBar = $("#search-bar");
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-search-toggle]")) {
      searchBar && searchBar.classList.toggle("is-open");
      var inp = searchBar && $("input[name=q]", searchBar);
      if (inp && searchBar.classList.contains("is-open")) setTimeout(function () { inp.focus(); }, 50);
    }
    if (e.target.closest("[data-search-close]")) searchBar && searchBar.classList.remove("is-open");
  });

  /* ── Menu mobile ───────────────────────────────────────── */
  var mobileMenu = $("#mobile-menu");
  var mobileScrim = $("[data-mobile-scrim]");
  function openMobile() { mobileMenu && mobileMenu.classList.add("is-open"); mobileScrim && mobileScrim.classList.add("is-open"); }
  function closeMobile() { mobileMenu && mobileMenu.classList.remove("is-open"); mobileScrim && mobileScrim.classList.remove("is-open"); }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-mobile-menu-open]")) openMobile();
    if (e.target.closest("[data-mobile-menu-close]")) closeMobile();
    if (e.target === mobileScrim) closeMobile();
  });

  /* ── Tiroir panier ─────────────────────────────────────── */
  var drawer = $("[data-cart-drawer]");
  var drawerScrim = $("[data-cart-scrim]");
  function openCart() { drawer && drawer.classList.add("is-open"); drawerScrim && drawerScrim.classList.add("is-open"); }
  function closeCart() { drawer && drawer.classList.remove("is-open"); drawerScrim && drawerScrim.classList.remove("is-open"); }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-open]")) { openCart(); refreshCart(); }
    if (e.target.closest("[data-cart-close]")) closeCart();
    if (e.target === drawerScrim) closeCart();
  });

  /* ── Rendu du tiroir depuis /cart.js ──────────────────── */
  var FREE_SHIP = (window.camsFreeShip || 7500); // cents
  function refreshCart() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }
  function updateCount(n) {
    $$(".cart-count").forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? "" : "none";
    });
  }
  function renderCart(cart) {
    updateCount(cart.item_count);
    var body = $("[data-cart-body]");
    var foot = $("[data-cart-foot]");
    var titleCount = $("[data-cart-titlecount]");
    if (titleCount) titleCount.textContent = cart.item_count > 0 ? (cart.item_count + " article" + (cart.item_count > 1 ? "s" : "")) : "Vide";
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="drawer__empty">' +
        '<p class="display" style="font-family:var(--serif);font-size:26px">Votre panier est vide</p>' +
        '<p style="color:var(--ink-faint);font-size:14px">Ajoutez un bijou d\'élégance parisienne.</p>' +
        '<button class="btn" style="margin-top:22px" data-cart-close>Explorer la Boutique</button>' +
        '</div>';
      if (foot) foot.innerHTML = "";
      return;
    }

    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") : "";
      return '' +
        '<div class="line" data-key="' + it.key + '">' +
          '<div class="line__media">' + (img ? '<img src="' + img + '" alt="" style="width:72px;height:84px;object-fit:cover;display:block">' : '') + '</div>' +
          '<div>' +
            '<div class="line__name">' + it.product_title + '</div>' +
            '<div class="line__meta">' + (it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : it.product_type || "CAMS Jewelry") + '</div>' +
            '<div class="qty">' +
              '<button data-qty-dec ' + (it.quantity <= 1 ? "disabled" : "") + '>−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button data-qty-inc>+</button>' +
            '</div>' +
          '</div>' +
          '<div class="line__right">' +
            '<span class="line__price">' + money(it.final_line_price) + '</span>' +
            '<button class="line__remove" data-remove>Retirer</button>' +
          '</div>' +
        '</div>';
    }).join("");

    if (foot) {
      var remaining = Math.max(FREE_SHIP - cart.total_price, 0);
      var progress = Math.min(cart.total_price / FREE_SHIP * 100, 100);
      var shipHtml = remaining > 0
        ? '<p class="ship-note">Plus que <b>' + money(remaining) + '</b> pour la livraison offerte</p>' +
          '<div class="ship-bar"><i style="width:' + progress + '%"></i></div>'
        : '<p class="ship-note" style="color:var(--gold-deep)"><b>🎉 Livraison offerte débloquée !</b></p>';
      foot.innerHTML =
        shipHtml +
        '<div class="drawer__row"><span>Sous-total</span><span>' + money(cart.total_price) + '</span></div>' +
        '<div class="drawer__row"><span>Livraison</span><span>' + (remaining > 0 ? "Calculée à la commande" : "Offerte") + '</span></div>' +
        '<div class="drawer__total"><span class="lab">Total</span><b>' + money(cart.total_price) + '</b></div>' +
        '<a href="/checkout" class="btn btn--full btn--gold" style="margin-top:16px">Valider la Commande</a>' +
        '<p class="drawer__note">Paiement sécurisé · Chiffrement SSL</p>';
    }
  }

  /* ── Ajout / modification / suppression panier ─────────── */
  document.addEventListener("click", function (e) {
    var add = e.target.closest("[data-add-to-cart]");
    if (add) {
      e.preventDefault();
      var id = add.getAttribute("data-variant-id");
      var title = add.getAttribute("data-title") || "Article";
      if (!id) return;
      add.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      }).then(function (r) { return r.json(); })
        .then(function () { toast(title + " ajouté au panier"); return refreshCart(); })
        .then(function () { openCart(); })
        .catch(function () { toast("Erreur — réessayez"); })
        .finally(function () { add.disabled = false; });
    }

    var line = e.target.closest(".line");
    if (line) {
      var key = line.getAttribute("data-key");
      var qtySpan = $(".qty span", line);
      var current = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
      if (e.target.closest("[data-qty-inc]")) changeQty(key, current + 1);
      if (e.target.closest("[data-qty-dec]")) changeQty(key, Math.max(current - 1, 0));
      if (e.target.closest("[data-remove]")) changeQty(key, 0);
    }
  });
  function changeQty(key, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  /* ── Favoris (localStorage) ────────────────────────────── */
  var WISH_KEY = "cams_wishlist";
  function getWish() { try { return JSON.parse(localStorage.getItem(WISH_KEY) || "[]"); } catch (e) { return []; } }
  function setWish(a) { localStorage.setItem(WISH_KEY, JSON.stringify(a)); }
  function paintWish() {
    var w = getWish();
    $$("[data-wishlist-toggle]").forEach(function (btn) {
      btn.classList.toggle("is-on", w.indexOf(btn.getAttribute("data-wishlist-toggle")) !== -1);
    });
  }
  document.addEventListener("click", function (e) {
    var wb = e.target.closest("[data-wishlist-toggle]");
    if (!wb) return;
    e.preventDefault();
    var id = wb.getAttribute("data-wishlist-toggle");
    var w = getWish();
    var i = w.indexOf(id);
    if (i === -1) { w.push(id); toast("Ajouté aux favoris"); } else { w.splice(i, 1); }
    setWish(w);
    paintWish();
  });

  /* ── Filtres grille produits (client) ──────────────────── */
  document.addEventListener("click", function (e) {
    var f = e.target.closest(".filter[data-filter]");
    if (!f) return;
    var grid = f.closest(".section");
    $$(".filter", grid).forEach(function (b) { b.classList.remove("is-active"); });
    f.classList.add("is-active");
    var val = f.getAttribute("data-filter");
    $$(".card[data-product-type]", grid).forEach(function (card) {
      var t = card.getAttribute("data-product-type");
      card.style.display = (val === "all" || t === val) ? "" : "none";
    });
  });

  /* ── Init ──────────────────────────────────────────────── */
  document.addEventListener("DOMContentLoaded", function () {
    paintWish();
    refreshCart();
  });
})();
